import React, { useState, useEffect } from "react";
import { URL } from "../Redux/common/url";
import { Modal, Button, Form } from "react-bootstrap";
import { Link } from "react-router-dom";

function OurServices() {
   const [productLists, setProductListt] = useState([]);
  const [show, setShow] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  useEffect(() => {
    fetchProductList();
  }, []);

  const fetchProductList = async () => {
    try {
      const response = await fetch(`${URL.API_BASE_URL}/publicApi/projectListPublic`);
      if (response.ok) {
        const data = await response.json();
        setProductListt(data?.project || []);
      }
    } catch (error) {
      console.error("Fetch error:", error);
    }
  };

  const handleShow = (product) => {
    setSelectedProduct(product);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setFormData({ name: "", email: "", phone: "" });
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  // ✅ Submit enquiry to backend
  const handleSubmit = async (e) => {
    e.preventDefault();

    const enquiryData = {
      name: formData.name,
      email: formData.email,
      mobile: formData.mobile,
       address: formData.address,
      product: selectedProduct?.title,
    };

    try {
      const response = await fetch(`${URL.API_BASE_URL}/publicApi/createContact`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(enquiryData),
      });

      const data = await response.json();

      if (response.ok) {
        alert(data.message || "Enquiry submitted successfully!");
        handleClose();
      } else {
        alert(data.message || "Failed to submit enquiry.");
      }
    } catch (error) {
      console.error("Error submitting enquiry:", error);
      alert("Something went wrong!");
    }
  };
  return (
    <div className="px-0 mt-4">
      <div className="container-fluid home-background-color">
        <div className="row py-5">
          <h1 className="fw-bold text-center text-white">OUR SERVICES</h1>
          <h2 className="text-white fw-bold text-center mb-4">
            Explore Our Range of Solar Services
          </h2>

          {productLists && productLists.length > 0 ? (
            productLists.map((item, index) => (
              <div className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4 my-5 " key={index}>
                <div className="card h-100 rounded-4 mx-1 overflow-hidden bg-light bg-opacity-50 p-3">
                  <Link to={`/products`}>
                  <img
                    src={URL?.API_BASE_URL + item?.feature_image}
                    className="card-img-topmk py-0 rounded-top-4 product-img-out"
                    alt={item.feature_image}
                    style={{ width: "100%"}}
                  />
                  </Link>
                  <div className="card-body text-center">
                     <Link to={`/products`} style={{ textDecoration: "none" }}>
                    <h5 className="card-title fw-bold text-dark">{item.title}</h5>
                     </Link>
                    <Button variant="" style={{ backgroundColor: '#07fa38' }} onClick={() => handleShow(item)} className="px-4 mt-2">
                      Enquiry
                    </Button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <p>Loading...</p>
          )}
        </div>
      </div>

      {/* 🔹 Enquiry Modal */}
      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Enquiry for {selectedProduct?.title}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleSubmit}>
            <Form.Group className="mb-3">
              <Form.Label>Name</Form.Label>
              <Form.Control
                type="text"
                name="name"
                placeholder="Enter your name"
                value={formData.name}
                onChange={handleChange}
                required
              />
            </Form.Group>
  <Form.Group className="mb-3">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="tel"
                name="mobile"
                placeholder="Enter your Phone number"
                value={formData.mobile}
                onChange={handleChange}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                name="email"
                placeholder="Enter your email"
                value={formData.email}
                onChange={handleChange}
                required
              />
            </Form.Group>
   <Form.Group className="mb-3">
              <Form.Label>City</Form.Label>
              <Form.Control
                type="text"
                name="address"
                placeholder="Enter your city"
                value={formData.address}
                onChange={handleChange}
                required
              />
            </Form.Group>
            {/* <Form.Group className="mb-3">
              <Form.Label>Message</Form.Label>
              <Form.Control
                as="textarea"
                rows={3}
                name="message"
                placeholder="Enter your enquiry"
                value={formData.message}
                onChange={handleChange}
              />
            </Form.Group> */}

            <Button variant="success" type="submit">
              Submit Enquiry
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </div>
  );
}

export default OurServices;
